import store from '@/store'
import { auth } from '@/auth/hyper-auth'

/**
 *
 * @returns Boolean - if user is logged
 */
const isUserLoggedIn = async () => {
    if (localStorage.getItem(auth.authConfig.storageTokenKeyName)) {
        if (!store.getters.authUserInfo.userIdx) {
            await store.dispatch('getAuthResource')
        }
        return true
    }
    return false
}

const getUserInfo = () => store.getters.authUserInfo

const getNeedPrerequisite = () => store.getters.needPrerequisite

const getAuthResource = () => store.getters.authUserResource

const getAuthPrerequisites = () => store.getters.authPrerequisites

export {
    isUserLoggedIn,
    getUserInfo,
    getNeedPrerequisite,
    getAuthResource,
    getAuthPrerequisites
}
